import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values = {
    enabled: Boolean
  }

  connect() {
    // Set initial state based on the data attribute
    if (this.enabledValue) {
      this.contentTarget.style.display = "block"
      this.contentTarget.style.opacity = "1"
      this.contentTarget.style.transform = "translateY(0)"
    } else {
      this.contentTarget.style.display = "none"
      this.contentTarget.style.opacity = "0"
      this.contentTarget.style.transform = "translateY(-10px)"
    }
  }

  toggle() {
    const isEnabled = this.element.querySelector("#jit_provisioning_enabled").checked
    this.toggleContent(isEnabled)
  }

  toggleContent(show) {
    if (show) {
      this.contentTarget.style.display = "block"
      // Trigger animation
      requestAnimationFrame(() => {
        this.contentTarget.style.opacity = "1"
        this.contentTarget.style.transform = "translateY(0)"
      })
    } else {
      this.contentTarget.style.opacity = "0"
      this.contentTarget.style.transform = "translateY(-10px)"
      // Wait for animation to complete before hiding
      setTimeout(() => {
        this.contentTarget.style.display = "none"
      }, 300)
    }
  }
} 